import type { ImpersonationTarget } from '@entities/member';
import { Button } from '@shared/ui/button';

import { IMPERSONATION_BANNER_TEXT } from '../model/impersonation-banner.text';

export interface ImpersonationBannerProps {
  target: ImpersonationTarget;
  /** 이동과 종료 요청은 상위가 맡는다 */
  onEnd: () => void;
}

/** 대행 로그인 중임을 알리는 화면 맨 위 띠(높이 32, warning 면) + 대행 종료 버튼 */
export function ImpersonationBanner({ target, onEnd }: ImpersonationBannerProps) {
  return (
    <div
      role="region"
      aria-label={IMPERSONATION_BANNER_TEXT.label}
      data-slot="impersonation-banner"
      className="flex h-(--size-control-sm) w-full items-center justify-center gap-3 bg-bg-warning shadow-subtle"
    >
      <p role="status" className="text-on-warning typo-label">
        {IMPERSONATION_BANNER_TEXT.message(target.name, target.type)}
      </p>
      <Button variant="inverse" size="2xs" onClick={onEnd}>
        {IMPERSONATION_BANNER_TEXT.end}
      </Button>
    </div>
  );
}
